export const setError = 'setError';
export const clearErrorStore = 'clearErrorStore';
export const clearError = 'clearError';
